import {getClockType} from "../settings/calendar_settings";

class DateService {
    date;
    tz;

    constructor() {
        this.date = null;
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("hour")) {
            this.date = new Date();
            this.date.setHours(Number(urlParams.get("hour")));
            this.date.setMinutes(0);
        }
    }

    getDate() {
        if (this.date == null) {
            return new Date();
        } else {
            return new Date(this.date);
        }
    }

    setDate(date) {
        this.date = date;
        currentTime();
    }

    getTimestampSeconds() {
        return this.getDate() / 1000;
    }
}

export let dateService = new DateService();

export function currentTime(tz) {
    if (tz) {
        dateService.tz = tz;
    }

    let clockType = getClockType(); // Assuming getClockType is a method of dateService
    let options = { hour: '2-digit', minute: '2-digit' };

    if (clockType === "24") {
        options.hour12 = false; // 24-hour clock
    } else if (clockType === "12") {
        options.hour12 = true; // 12-hour clock
    } // if clockType is 'locale', no need to set hour12, it will use the user's locale preference.

    if (dateService.tz) {
        options.timeZone = dateService.tz;
    }
    let date = dateService.getDate();
    document.querySelector(".datetime-container .time").textContent = date.toLocaleTimeString([], options);
}